<template>
    <div id="installation-step">
        <v-stepper v-model="step" alt-labels class="elevation-0">
            <v-img :src="logo" alt="Logo four data" class="mt-4 img-header" contain max-height="80" />

            <v-row class="justify-center pt-6">
                <span>{{ $t('device_install') }}</span>
            </v-row>

            <v-stepper-header class="elevation-0 stepper-header">
                <v-stepper-step :complete="step > 1" step="1">
                    <span class="text-center">{{ $t('step_1.title') }}</span>
                </v-stepper-step>
                <v-divider />

                <v-stepper-step :complete="step > 2" step="2">
                    <span class="text-center">{{ $t('step_2.title') }}</span>
                </v-stepper-step>
                <v-divider />

                <v-stepper-step :complete="step > 3" step="3">
                    <span class="text-center">{{ !is_bee_2_beep ? $t('step_3.title') : $t('step_4.title') }}</span>
                </v-stepper-step>
                <v-divider v-if="!is_bee_2_beep" />

                <v-stepper-step v-if="!is_bee_2_beep" :complete="step > 4" step="4">
                    <span class="text-center">{{ $t('step_4.title') }} </span>
                </v-stepper-step>
                <v-divider v-if="!is_bee_2_beep && isStepConfigurationOptional()" />

                <v-stepper-step v-if="!is_bee_2_beep && isStepConfigurationOptional()" step="5">
                    <span class="text-center">{{ $t('step_5.title') }} </span>
                </v-stepper-step>
            </v-stepper-header>

            <div class="text-center">
                <p v-if="mobile">{{ $t('step_' + step + '.title') }}</p>
            </div>
            <v-stepper-items>
                <v-stepper-content class="stepper-content-background" step="1">
                    <installation-step-1
                        ref="installationStep1"
                        v-on:goToStepTwoWithUser="goToStepTwoWithUser"
                        v-on:goToStepTwoWithoutUser="goToStepTwoWithoutUser"
                        v-on:previousStep="previousStep"
                    />
                </v-stepper-content>

                <v-stepper-content class="stepper-content-background" step="2">
                    <installation-step-2
                        :device_number_scanned="device_number"
                        v-on:goToStepThree="goToStepThree"
                        v-on:previousStep="previousStep"
                    />
                </v-stepper-content>

                <v-stepper-content class="stepper-content-background" step="3">
                    <installation-step-3
                        v-if="!is_bee_2_beep"
                        :id_professional="id_professional"
                        :name_professional="name_professional"
                        :authorized_desk_version="authorized_desk_version"
                        v-on:goToStepFour="goToStepFour"
                        v-on:previousStep="previousStep"
                    />

                    <installation-step-4
                        v-else
                        ref="installationStep4"
                        :asset_type="asset_type"
                        :device_number="device_number"
                        :id_professional="id_professional"
                        :uid_professional="uid_professional"
                        :user="user"
                        :is-step5="isStepConfigurationOptional()"
                        v-on:goToResult="goToResult"
                        v-on:previousStep="previousStep"
                    />
                </v-stepper-content>

                <v-stepper-content class="stepper-content-background" step="4">
                    <installation-step-4
                        v-if="!is_bee_2_beep"
                        ref="installationStep4"
                        :asset_type="asset_type"
                        :device_number="device_number"
                        :id_device="id_device"
                        :id_professional="id_professional"
                        :uid_professional="uid_professional"
                        :user="user"
                        :is-step5="isStepConfigurationOptional()"
                        v-on:goToStepFive="goToStepFive"
                        v-on:goToResult="goToResult"
                        v-on:previousStep="previousStep"
                    />
                </v-stepper-content>

                <v-stepper-content class="stepper-content-background" step="5">
                    <installation-step-5
                        v-if="isStepConfigurationOptional"
                        ref="installationStep5"
                        :capacity="capacity"
                        :id_device="id_device"
                        :name_device_referentiel="name_device_referentiel"
                        :device_number="device_number"
                        :id_device_referentiel="id_device_referentiel"
                        :id_liquid="id_liquid"
                        :asset="asset"
                        v-on:goToResult="goToResult"
                        v-on:skipStep="skipStep"
                    />
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>

        <div v-if="show_loader" class="global-loader">
            <div class="loader" />
        </div>
    </div>
</template>

<script>
import { version } from '../../package.json'
import InstallationStepOneComponent from '../components/installation-step/installation-step-1.vue'
import InstallationStepTwoComponent from '../components/installation-step/installation-step-2.vue'
import InstallationStepThreeComponent from '../components/installation-step/installation-step-3.vue'
import InstallationStepFourComponent from '../components/installation-step/installation-step-4.vue'
import InstallationStepFiveComponent from '@/components/installation-step/Installation-step-5.vue'

export default {
    name: 'InstallationStep',
    components: {
        'installation-step-1': InstallationStepOneComponent,
        'installation-step-2': InstallationStepTwoComponent,
        'installation-step-3': InstallationStepThreeComponent,
        'installation-step-4': InstallationStepFourComponent,
        'installation-step-5': InstallationStepFiveComponent,
    },
    data() {
        return {
            show_loader: true,
            logo: '',
            url_platform: null,
            step: 1,
            user: null,
            id_device: null,
            id_liquid: 0,
            device_number: '',
            value_type_device: null,
            url_device_detail: '',
            id_professional: null,
            id_device_referentiel: 0,
            authorized_desk_version: '',
            name_device_referentiel: '',
            name_liquid: '',
            name_commercial_asset: '',
            uid_professional: '',
            name_professional: '',
            asset: null,
            capacity: 0,
            address: '',
            asset_type: {
                id_referential: null,
                key: '',
                value: '',
                id_asset_generic_module: null,
                id_module: null,
            },
            installation: {
                notice: '',
                description: '',
                introduction: '',
            },
            type_snackbar: '',
            message: '',
            show_snackbar: false,
        }
    },
    computed: {
        mobile() {
            return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
        },
        is_bee_2_beep() {
            return this.$store.getters['global/is_bee_2_beep']
        },
    },
    beforeCreate() {
        this.$store.dispatch('autofill/fillParams', this.$route.query)

        let url = '/api/v1/display_option'
        if (this.$route.query.device_number && this.$route.query.device_number !== '') {
            url += '/device/' + this.$route.query.device_number
        } else if (this.$route.params.param !== undefined) {
            url += '/' + this.$route.params.param
        } else {
            url += '/tunnel_installation'
        }

        this.axios
            .get(url)
            .then((success) => {
                this.logo = success.data.data.src_logo
                if (this.device_number === '') {
                    this.url_platform = success.data.data.url_platform
                }

                if (success.data.data.tunnel_installation_url === 'installation.bee2beep.com') {
                    this.$store.dispatch('global/setIsBee2Beep', true)
                    this.asset_type = {
                        id_referential: 230,
                        key: 'generic',
                        value: 'Ruche',
                        id_asset_generic_module: 5,
                    }
                }

                this.$vuetify.theme.themes.light.primary = success.data.data.primary
                document.getElementById('favicon').href = success.data.data.src_favicon
            })
            .catch((error) => {
                this.manageError('warning', this.$t('error_display_option'), error)
            })
            .finally(() => {
                if (this.$store.getters['global/application_version'] === version || process.env.NODE_ENV === 'local') {
                    setTimeout(() => {
                        this.show_loader = false
                    }, 1000)
                } else if (!this.$store.getters['global/application_version']) {
                    //In case current service worker version is already set, but store has been clear
                    this.$store.dispatch('global/setApplicationVersion', version)

                    setTimeout(() => {
                        window.location.reload()
                    }, 1000)
                } else {
                    this.$store.dispatch('global/setApplicationVersion', version)
                }
            })
    },
    methods: {
        goToStepTwoWithUser(item) {
            this.$store.dispatch('global/with_user')
            this.show_information_message = false
            this.device_number = this.$route.query.device_number
            this.user = item.user
            this.step = 2
        },

        goToStepTwoWithoutUser() {
            this.$store.dispatch('global/without_user')

            if (this.device_number === '' && this.$route.query.device_number && this.$route.query.device_number !== '') {
                this.device_number = this.$route.query.device_number
            }
            this.step = 2
        },

        goToStepThree(item) {
            this.id_professional = item.id_professional
            this.uid_professional = item.uid_professional
            this.id_device = item.id_device
            this.id_device_referentiel = item.id_device_referentiel
            this.getExternalInstallerName(this.id_device_referentiel)
            this.value_type_device = item.value_type_device
            this.device_number = item.device_number
            this.url_device_detail = item.url_device_detail
            this.name_professional = item.name_professional
            this.installation = item.installation
            this.authorized_desk_version = item.authorized_desk_version
            this.step = 3
        },

        goToStepFour(item) {
            this.asset_type = { ...item.asset_type }
            this.step = 4
            if (this.asset_type.id_module === null) {
                this.nextTick(() => {
                    this.$refs.installationStep4.resetForm()
                })
            }
        },

        async goToStepFive(item) {
            if (this.asset_type.id_module === null || (this.step === 5 && !this.isStepConfigurationOptional())) {
                this.goToResult()
            }
            this.asset = item.asset
            this.id_liquid = item.asset.asset_models[0].id_asset_liquid

            await this.getContentName()
            await this.getDenominationCommercialName(this.asset.asset_models[0].configuration)
            this.capacity = this.asset.asset_models[0].configuration.total_volume
            this.address = this.asset.domicile.route + ' ' + this.asset.domicile.postal_code + ', ' + this.asset.domicile.country
            this.$refs.installationStep5.address = this.address
            this.$refs.installationStep5.name_liquid = this.name_liquid
            this.$refs.installationStep5.configuration = this.asset.asset_models[0].configuration ?? {}
            this.$refs.installationStep5.name_commercial_asset = this.name_commercial_asset

            this.step = 5
        },

        goToResult() {
            this.$router.push({
                name: 'result',
                params: {
                    id_device: this.id_device,
                    device_number: this.device_number,
                    url_device_detail: this.url_device_detail,
                    id_professional: this.id_professional,
                    email: this.$refs.installationStep1.email,
                    value_type_device: this.value_type_device,
                    url_platform: this.url_platform,
                    installation: this.installation,
                    id_module: this.asset_type.id_module,
                },
            })
        },

        previousStep() {
            this.step--
        },

        skipStep() {
            this.goToResult()
        },

        getExternalInstallerName() {
            return this.axios
                .get('api/v1/device_referentiel/' + this.id_device_referentiel + '/name')
                .then((success) => {
                    this.name_device_referentiel = success.data.data
                })
                .catch((error) => {
                    this.manageError('error', this.$t('step_4.error_during_installation'), error)
                })
        },

        async getContentName() {
            return this.axios
                .get('api/v1/liquid/' + this.id_liquid + '/name')
                .then((success) => {
                    this.name_liquid = success.data.data
                })
                .catch((error) => {
                    this.manageError('error', this.$t('step_4.error_during_installation'), error)
                })
        },

        async getDenominationCommercialName(configuration) {
            if (configuration && configuration.id_asset_reference) {
                return this.axios
                    .get('api/v1/asset_model_reference/' + configuration.id_asset_reference)
                    .then((success) => {
                        this.name_commercial_asset = success.data.data.trade_name
                    })
                    .catch((error) => {
                        this.manageError('error', this.$t('step_4.error_during_installation'), error)
                    })
            }
        },

        isStepConfigurationOptional() {
            if (this.id_device_referentiel !== null) {
                switch (this.id_device_referentiel) {
                    case 244: // Nee-Vo
                        return true
                    default:
                        return false
                }
            }
            return false
        },
    },
    mounted() {
        if (this.$route.query.device_number && this.$route.query.device_number !== '') {
            this.device_number = this.$route.query.device_number
        }
    },
}
</script>

<style scoped>
.img-header {
    max-width: 300px;
    margin: auto;
}

.stepper-content-background {
    background-color: #e5e5e5 !important;
}

.stepper-header {
    max-width: 1000px;
    margin: auto;
}

.v-stepper__step {
    padding: 24px 20px;
}
</style>
